/**
 * Enums
 */
export * from './enums/ApiVersionEnum.js'
export * from './enums/VoiceGenderTypeEnum.js'
export * from './enums/LanguageEnum.js'
export * from './enums/ClientTypeEnum.js'
export * from './enums/SSETypeEnum.js'
export * from './enums/ErrorCodeEnum.js'
export * from './enums/AuthErrorCodeEnum.js'

/**
 * API
 */
export * from './v1/index.js'
export * from './v1/Appointments.js'
export * from './v1/ShortUrl.js'
export * from './v1/Sessions.js'
export * from './v1/dto/SessionsDTO.js'
export * from './v1/dto/AppointmentsDTO.js'
export * from './v1/dto/ShortUrlDTO.js'
export * from './v1/dto/baseDTO.js'
export * from './v1/Viewer.js'
export * from './v1/dto/ViewerDTO.js'
export * from './api.js'
export * from './v1/dto/ChannelDTO.js'
export * from './v1/Channel.js'

/**
 * Licence API（MEB licence 登入）
 */
export * from './licence/dto.js'
export * from './licence/Auth.js'

/**
 * Dashboard API（admin / 統計報表 / 版本 / SSE connect）
 */
export * from './v1/admin/dto.js'
export {
	AdminApiError,
	AUTH_UNAVAILABLE_MESSAGE,
	adminHttpClient,
	setAuthErrorHandlers,
	type AuthErrorHandlers,
} from './v1/admin/client.js'
export * from './v1/admin/Auth.js'
export * from './v1/admin/Channel.js'
export * from './v1/admin/Dashboard.js'
export * from './v1/admin/Report.js'
export * from './v1/admin/Stats.js'
